<template>
  <el-container style="height: 100%" :style="{ color: color }">
    <el-aside :style="{ backgroundColor: sideBack, width: 'auto' }" class="aside-animate">
      <sidebar class="sidebar-container" />
    </el-aside>
    <el-container>
      <el-header :style="{ backgroundColor: headerBack }" height="85px">
        <head-bar />
      </el-header>
      <el-main class="element-main" ref="element">
        <keep-alive>
          <router-view :key='key' v-if="isKeepAlive" />
        </keep-alive>
        <router-view v-if="!isKeepAlive" :key='key' />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Sidebar from './Sidebar'
import HeadBar from './Header'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    HeadBar
  },
  data() {
    return {

    }
  },
  watch: {
    $route() {
      let p = document.querySelector('.element-main')
      this.$nextTick(() => {
        p.scrollTop = 0
      })
    },
    visitedViews(val){
      const keepUrl = '/engineeringProjectSetting/engineeringAudit'
      const keepUrl1 = '/engineeringProjectSetting/engineeringApprove'
      const hasAudit = val.find(item =>item.path===keepUrl)
      const hasApprove = val.find(item =>item.path===keepUrl1)
     setTimeout(() => {
      if (!hasAudit && localStorage.getItem('engineeringAuditDetail')) localStorage.removeItem('engineeringAuditDetail')
      if (!hasApprove && localStorage.getItem('engineeringApproveDetail')) localStorage.removeItem('engineeringApproveDetail')
     }, 0);
    }
  },

  computed: {
    keepAliveList() {
      return this.$store.state.app.keepAliveList
    }, 
    visitedViews() {
      return this.$store.state.tag.visitedViews
    }, 
    isKeepAlive() {
      return this.keepAliveList.includes(this.$route.path)
    },
    sideWidth: function () {
      return this.$store.state.app.sideWidth
    },
    sideCloseWidth: function () {
      return this.$store.state.app.sideCloseWidth
    },
    sidebar: function () {
      return this.$store.state.app.sidebar
    },
    sideBack: function () {
      return this.$store.state.app.theme.sideBack
    },
    headerBack: function () {
      return this.$store.state.app.theme.headerBack
    },
    mainBack: function () {
      return this.$store.state.app.theme.mainBack
    },
    mainColor: function () {
      return this.$store.state.app.theme.mainColor
    },
    color: function () {
      return this.$store.state.app.theme.color
    },
    key() {
      return this.$route.path
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.aside-animate {
  transition: width 0.5s;
}

.sidebar-container {
  /*transition: width 0.28s;*/
}

.element-main {
  padding: 20px 12px 0 20px;
  background-color: #f6f8f9;
  overflow-y: scroll;
  height: calc(100vh - 85px);
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue